import styled from 'styled-components'

export const StyledTitle = styled.h2`
    font-weight: bold;
    font-size: 2.3em;
`
export const StyledContent = styled.div``
export const StyledLogo = styled.img`
    width: 100%;
    height: auto;
`